<div class="login-container">
    <div class="card-container">
        <div class="login-card">
            <img src="../../../../assets/images/AllyLogoDark.svg" alt="AndDone Logo" class="anddone-logo" />
            <h5>
                {{ "forgotPassword.recoverPassword" | translate }}
            </h5>
            <p>{{ "forgotPassword.note" | translate }}</p>
            <form [formGroup]="forgotPasswordForm">
                <div class="input-container">
                    <label for="loginUsername">
                        <span class="required">*</span>
                        {{ "login.userName" | translate }}
                    </label>
                    <input type="email" id="userEmail" placeholder="Username" required formControlName="userName" />
                    <span class="error-text"><img src="../../../../assets/images/Warning.svg" alt="warning icon">
                        {{ forgotPasswordFormErrors.userName }}
                    </span>
                </div>
                <div class="button-container">
                    <a class="button button-clear" (click)="back()"><span>{{ "common.back" | translate }}</span></a>
                    <a class="button button-green" (click)="executeRecaptcha()">
                        <span>
                            @if (isLoader()) {
                                <span class="spinner-border spinner-border-sm"></span>
                            }
                            <span> {{ "common.submit" | translate }}</span>
                        </span>
                    </a>
                </div>
            </form>
        </div>
        <div class="login-footer">
            <span>{{'footer.copyrightText1'|translate}} {{currentYear}} {{'footer.copyrightText2'|translate}}</span>
            <a (click)="goToLink(appSetting.privacyPolicyUrl)"
                target="currentwindow1">{{'footer.privacyStatement'|translate}}</a>
            <a (click)="goToLink(appSetting.termsOfUseUrl)"
                target="currentwindow2">{{'footer.termsOfService'|translate}}</a>
        </div>
    </div>
</div>